import dayjs, { Dayjs } from 'dayjs';

import { DateFormats } from '../config';

export const getFullTextDate = (value: string | Dayjs) => {
  return dayjs(value).format(DateFormats.FullTextDate).replace(' г.', '');
};

export const getClearDate = (value?: string): string[] => {
  const result = value?.match(/(Date\()(\d+\+\d+)(\))/i);

  return Array.isArray(result) ? result[2].split('+') : [];
};

export const getFormatedDate = (value: string): string => {
  const [timestamp, tz] = getClearDate(value);

  if (!timestamp || !tz) {
    return value;
  }

  return dayjs(Number(timestamp)).toISOString().replace('000Z', `${tz}Z`);
};

export const getTaskTitleDate = (value: string): string => {
  return getFullTextDate(getFormatedDate(value));
};

export const getTaskGroupKeyDate = (value: string): string => {
  return dayjs(getFormatedDate(value)).format(DateFormats.Iso);
};

export const getHistoryDate = (value?: string) => {
  const [timestamp] = getClearDate(value);
  const date = dayjs(+timestamp);

  return date.isValid()
    ? {
        day: date.format('DD'),
        month: date.format('MMMM'),
      }
    : {
        day: '',
        month: '',
      };
};
